class DimensionRange extends HTMLElement {
  constructor() {
    super();

    this.rangeMin = this.querySelector('input[type="range"]:first-child');
    this.rangeMax = this.querySelector('input[type="range"]:last-child');
    this.inputMin = this.querySelector('[data-dimension-min]');
    this.inputMax = this.querySelector('[data-dimension-max]');
    this.checkboxes = this.querySelectorAll('.m-dimension-filter-values input[type="checkbox"]');
    this.filterLabel = this.dataset.filterLabel || '';

    if (!this.rangeMin || !this.rangeMax || !this.inputMin || !this.inputMax) {
      return;
    }

    this.inputMin.addEventListener("focus", () => this.inputMin.select());
    this.inputMax.addEventListener("focus", () => this.inputMax.select());
    this.inputMin.addEventListener("change", this.onInputMinChange.bind(this));
    this.inputMax.addEventListener("change", this.onInputMaxChange.bind(this));

    this.rangeMin.addEventListener("change", this.onRangeMinChange.bind(this));
    this.rangeMax.addEventListener("change", this.onRangeMaxChange.bind(this));
    this.rangeMin.addEventListener("input", this.onRangeMinInput.bind(this));
    this.rangeMax.addEventListener("input", this.onRangeMaxInput.bind(this));
  }

  onInputMinChange(event) {
    event.preventDefault();
    const minVal = parseInt(event.target.value) || parseInt(this.rangeMin.min);
    const maxVal = parseInt(this.inputMax.value) || parseInt(this.rangeMax.max);
    const constrainedMin = Math.max(
      Math.min(minVal, maxVal - 1),
      parseInt(this.rangeMin.min)
    );
    event.target.value = constrainedMin;
    this.rangeMin.value = constrainedMin;
    this.updateCheckboxes();
    this.updateProgress();
    // Trigger form submission
    const form = this.closest('form');
    if (form) {
      form.dispatchEvent(new Event("input", { bubbles: true }));
    }
  }

  onInputMaxChange(event) {
    event.preventDefault();
    const maxVal = parseInt(event.target.value) || parseInt(this.rangeMax.max);
    const minVal = parseInt(this.inputMin.value) || parseInt(this.rangeMin.min);
    const constrainedMax = Math.min(
      Math.max(maxVal, minVal + 1),
      parseInt(this.rangeMax.max)
    );
    event.target.value = constrainedMax;
    this.rangeMax.value = constrainedMax;
    this.updateCheckboxes();
    this.updateProgress();
    // Trigger form submission
    const form = this.closest('form');
    if (form) {
      form.dispatchEvent(new Event("input", { bubbles: true }));
    }
  }

  onRangeMinChange(event) {
    event.stopPropagation();
    const minVal = parseInt(event.target.value);
    this.inputMin.value = minVal;
    this.updateCheckboxes();
    this.inputMin.dispatchEvent(new Event("change", { bubbles: true }));
    // Trigger form submission
    const form = this.closest('form');
    if (form) {
      form.dispatchEvent(new Event("input", { bubbles: true }));
    }
  }

  onRangeMaxChange(event) {
    event.stopPropagation();
    const maxVal = parseInt(event.target.value);
    this.inputMax.value = maxVal;
    this.updateCheckboxes();
    this.inputMax.dispatchEvent(new Event("change", { bubbles: true }));
    // Trigger form submission
    const form = this.closest('form');
    if (form) {
      form.dispatchEvent(new Event("input", { bubbles: true }));
    }
  }

  onRangeMinInput(event) {
    const minVal = parseInt(event.target.value);
    const maxVal = parseInt(this.rangeMax.value);
    const constrainedMin = Math.min(minVal, maxVal - 1);
    event.target.value = constrainedMin;
    this.inputMin.value = constrainedMin;
    // Don't update checkboxes or trigger form submission while dragging
    // Only update visual progress
    this.updateProgress();
  }

  onRangeMaxInput(event) {
    const maxVal = parseInt(event.target.value);
    const minVal = parseInt(this.rangeMin.value);
    const constrainedMax = Math.max(maxVal, minVal + 1);
    event.target.value = constrainedMax;
    this.inputMax.value = constrainedMax;
    // Don't update checkboxes or trigger form submission while dragging
    // Only update visual progress
    this.updateProgress();
  }

  updateProgress() {
    const minVal = parseInt(this.rangeMin.value);
    const maxVal = parseInt(this.rangeMax.value);
    const minRange = parseInt(this.rangeMin.min);
    const maxRange = parseInt(this.rangeMax.max);
    const rangeSpan = maxRange - minRange;

    if (rangeSpan > 0) {
      const fromPercent = ((minVal - minRange) / rangeSpan) * 100;
      const toPercent = ((maxVal - minRange) / rangeSpan) * 100;
      this.style.setProperty("--from", `${fromPercent}%`);
      this.style.setProperty("--to", `${toPercent}%`);
    }
  }

  updateCheckboxes() {
    const minVal = parseInt(this.inputMin.value) || parseInt(this.rangeMin.min);
    const maxVal = parseInt(this.inputMax.value) || parseInt(this.rangeMax.max);

    this.checkboxes.forEach((checkbox) => {
      const value = parseFloat(checkbox.dataset.dimensionValue) || 0;
      const wasChecked = checkbox.checked;
      const shouldBeChecked = value >= minVal && value <= maxVal;
      
      if (wasChecked !== shouldBeChecked) {
        checkbox.checked = shouldBeChecked;
        // Trigger change event to notify form
        checkbox.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
  }
}

customElements.define("dimension-range", DimensionRange);

